import type { EpicOption } from '@atlassian/jira-issue-field-epic-link';
import type { JiraEpic, JiraEpicLinkFieldInput } from './types';

export const transformDefaultEpicValue = ({ key, summary }: JiraEpic): EpicOption => ({
	label: summary,
	value: key,
});

export const mutateEpicLinkField = (
	{ value }: EpicOption,
	fieldId: string,
): JiraEpicLinkFieldInput => ({
	epicLinkField: {
		fieldId,
		epicLink: {
			issueKey: value,
		},
	},
});
